export const heroImages = [
  "/images/IMG-20250805-WA0142.webp",
  "/images/interrior/hero section2.webp",
  "/images/interrior/Brown-living-room-ideas.webp",
];

export const services = [
  { icon: "sofa", title: "Interior Design & Renovation", desc: "Tailored designs that match your lifestyle and elevate your space.", image: "/images/services/service-1.webp" },
  { icon: "hammer", title: "Fit-Outs & Carpentry", desc: "Elegant carpentry and customized fit-outs built to perfection.", image: "/images/services/service-2.webp" },
  { icon: "snowflake", title: "Air Conditioning & Electrical", desc: "Energy-efficient and safety-compliant AC and electrical solutions.", image: "/images/services/service-3.webp" },
  { icon: "leaf", title: "Landscaping & Outdoor", desc: "Designing serene and functional outdoor living spaces.", image: "/images/services/service-4.webp" },
  { icon: "paintbrush", title: "Painting & Flooring", desc: "Premium finishes using top-quality paints and materials.", image: "/images/services/service-5.webp" },
  { icon: "sun", title: "WPC Outdoor Decking", desc: "Durable, eco-friendly WPC decking solutions engineered for Dubai's climate.", image: "/images/services/service-6.webp", link: "/wpc-outdoor-decking" },
];

export const whyChooseUs = [
  { icon: "users", title: "Experienced Team", desc: "Skilled professionals with years of industry expertise" },
  { icon: "zap", title: "Timely Execution", desc: "Fast turnaround with high-quality work" },
  { icon: "tag", title: "Affordable Packages", desc: "Flexible options for every budget" },
  { icon: "headset", title: "24/7 Support", desc: "Emergency services available anytime" },
  { icon: "shield-check", title: "Certified & Insured", desc: "Reliable, safe, and fully insured" },
];

export const servicePackages = [
  {
    name: "Minimal",
    price: "AED 108–125/sqft",
    style: "Clean | Essential | Cost-Efficient",
    perfectFor: "Budget homes, rentals, first-time buyers",
    features: ["Neutral wall paint", "Ceramic/laminate flooring", "Ready-made MDF kitchen", "Standard fixtures", "Ceiling fans", "Functional lighting"],
    image: "/images/packages/pkg-1.webp",
    featured: false,
  },
  {
    name: "Modern",
    price: "AED 133–151/sqft",
    style: "Sleek | Urban | Functional",
    perfectFor: "Airbnb homes, small families",
    features: ["Feature walls", "Vinyl/matte porcelain flooring", "Modular kitchen with quartz", "LED mirrors", "Smart switches"],
    image: "/images/packages/pkg-2.webp",
    featured: true,
  },
  {
    name: "Luxury",
    price: "AED 205–271/sqft",
    style: "Elegant | Custom | High-End Finishes",
    perfectFor: "Upscale homeowners, value maximizers",
    features: ["Textured finishes", "Italian marble flooring", "Designer kitchen", "Grohe/Kohler bathroom fittings", "Walk-in wardrobes", "Full smart automation"],
    image: "/images/packages/pkg-3.webp",
    featured: false,
  },
  {
    name: "Signature Bespoke",
    price: "AED 291–308/sqft",
    style: "Architectural | Bespoke | Ultra-Premium",
    perfectFor: "Marina/Downtown homes, signature builds",
    features: ["Marble slab backsplashes", "Wood panel features", "Frameless glass partitions", "Smart curtain controls", "Custom vanities"],
    image: "/images/packages/pkg-4.webp",
    featured: false,
  },
];

export const testimonials = [
  { name: "Elena Rodriguez", role: "Property Investor", text: "BKD Contracting delivered our luxury renovation on time and within budget. The craftsmanship is exceptional.", initials: "ER" },
  { name: "Sarah Ahmed", role: "Dubai Marina Resident", text: "BKD Contracting transformed our apartment beyond expectations. The attention to detail and quality of work is outstanding.", initials: "SA" },
  { name: "Mohammed Al Rashid", role: "Business Owner", text: "Professional team, timely execution, and beautiful results. Highly recommend BKD Contracting for any renovation project.", initials: "MR" },
];

export const portfolioProjects = [
  { title: "Luxury Villa – Palm Jumeirah", before: "/images/Before & After/Palm Jumeirah-Before.webp", after: "/images/Before & After/Palm Jumeirah-After.avif" },
  { title: "Downtown Dubai Apartment", before: "/images/Before & After/Modern Apartment – Downtown Dubai-BEFORE.webp", after: "/images/Before & After/Modern Apartment – Downtown Dubai-AFTER.webp" },
  { title: "Office Space – Business Bay", before: "/images/Before & After/Office Space – Business Bay-before.webp", after: "/images/Before & After/Office Space – Business Bay-After.webp" },
];

export const portfolioImages = [
  "/images/portfolio-extra-1.webp",
  "/images/portfolio-extra-2.webp",
  "/images/portfolio-extra-3.webp",
  "/images/portfolio-extra-4.webp",
  "/images/services/service-1.webp",
  "/images/services/service-2.webp",
  "/images/services/service-3.webp",
  "/images/services/service-4.webp",
  "/images/services/service-5.webp",
  "/images/services/service-6.webp",
  "/images/packages/pkg-1.webp",
  "/images/packages/pkg-2.webp",
  "/images/packages/pkg-3.webp",
  "/images/packages/pkg-4.webp",
  "/images/spacesec1.webp",
  "/images/spacesec2.webp",
  "/images/spacesec3.webp",
  "/images/IMG-20250805-WA0147.webp",
  "/images/IMG-20250805-WA0152.webp",
  "/images/IMG-20250805-WA0143.webp",
  "/images/IMG-20250805-WA0149.webp",
  "/images/IMG-20250805-WA0151.webp",
  "/images/IMG-20250805-WA0145.webp",
  "/images/IMG-20250805-WA0140.webp",
  "/images/IMG-20250805-WA0153.webp",
  "/images/IMG-20250805-WA0148.webp",
  "/images/IMG-20250805-WA0142.webp",
  "/images/IMG-20250805-WA0146.webp",
  "/images/IMG-20250805-WA0139.webp",
  "/images/IMG-20250805-WA0141.webp",
  "/images/IMG-20250805-WA0150.webp",
  "/images/IMG-20250805-WA0144.webp",
  "/images/IMG-20250805-WA0138.webp",
];

export const partnershipImages = [
  "/images/partnership/WhatsApp Image 2025-08-06 at 17.15.05_9157f94d.webp",
  "/images/partnership/WhatsApp Image 2025-08-06 at 17.14.31_b3e2078f.webp",
  "/images/partnership/WhatsApp Image 2025-08-06 at 17.13.46_af198770.webp",
  "/images/partnership/WhatsApp Image 2025-08-06 at 17.13.05_dd15b325.webp",
];

export const teamMembers = [
  { name: "Ahmed Bilal", role: "Founder & CEO", image: "/images/IMG-20250805-WA0120.webp" },
  { name: "Sarah Johnson", role: "Lead Interior Designer", image: "/images/IMG-20250805-WA0111.webp" },
  { name: "Mohammed Ali", role: "Senior Project Manager", image: "/images/IMG-20250805-WA0110.webp" },
  { name: "Elena Rodriguez", role: "Architectural Consultant", image: "/images/IMG-20250805-WA0150.webp" },
];

export const aboutHighlights = [
  { icon: "award", title: "Quality Guaranteed", desc: "Premium materials, strict QC" },
  { icon: "clock", title: "On-Time Delivery", desc: "Deadlines we always meet" },
  { icon: "shield-check", title: "Licensed & Insured", desc: "Fully certified professionals" },
  { icon: "globe", title: "UAE-Wide Service", desc: "Residential & commercial" },
];

export const stats = [
  { end: 280, suffix: "+", label: "Satisfied Customers" },
  { end: 350, suffix: "+", label: "Expert In-House Team" },
  { end: 90, suffix: "+", label: "Quality Services" },
  { end: 100, suffix: "%", label: "Satisfaction Rate" },
];

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "About", to: "/about" },
];

export const contactInfo = {
  phone: "+971 55 834 4467",
  phoneRaw: "971558344467",
  email: "info@bkdcontracting.com",
  website: "www.bkdcontracting.com",
  hours: "Mon – Sat · 9am – 5pm",
};
